/**
 * Where "Change for all of Beyond" leads in the shared "Language and appearance" dialog (D07, D54): the
 * Accounts account page the family bar's descriptor names, told which product sent the person and the
 * address to come back to. Without that page nothing is offered.
 *
 * The family bar fixes the dialog's link when it is created, so the way back is the screen and scope in
 * view (`back`), without the list's words, filter or page: the bar is made again only when the person
 * moves to another screen or scope, never while typing a search.
 */
export class Everywhere {
	static address(account: string | undefined, back: string): string | undefined {
		if (!account) return undefined;
		try {
			const url = new URL(account);
			url.searchParams.set('product', 'snapshots');
			url.searchParams.set('return', new URL(back, globalThis.location.origin).href);
			return url.href;
		} catch {
			return undefined;
		}
	}
}
